import React, { useState, useEffect, Fragment, useMemo } from "react";
import Moment from "react-moment";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Accordion from "react-bootstrap/Accordion";
import { taskImages } from "../../constants/roles";
import { FaStar } from "react-icons/fa";
import { BiSolidDownArrow } from "react-icons/bi";
import {
  convertTimeToUserTimeZone,
  convertToTimeZone,
  extractTimeFromTimestamp,
  getFullName,
} from "../../utils/CommonFunctions";
import cx from "../Clients/clients.module.css";
import { wCategories } from "../../constants/constants";
import { BasicButton } from "../Clients/PublishDataTable";
import ImagePreviewModal from "../../components/ImagePreviewModal";
import moment from "moment";
import { useSelector } from "react-redux";

const ratingArr = [
  { star: 1 },
  { star: 2 },
  { star: 3 },
  { star: 4 },
  { star: 5 },
];
const JournalDetailAgency = (props) => {
  let { careteamJournal } = props;
  const { currentCareSiteData } = useSelector(
    (state) => state.caresiteDataReducer
  );

  const filteredNotes = useMemo(() => {
    // console.log(careteamJournal, "careteamJournal-----------");
    const filterByClientAndShift = careteamJournal?.notesData?.filter(
      (item) =>
        item?.careTeamId === careteamJournal?.careTeam?._id &&
        item.shiftId === careteamJournal.shiftId
    );
    const familyNotes = filterByClientAndShift?.filter(
      (item) => item?.notesType === "family"
    );
    const cateteamNotes = filterByClientAndShift?.filter(
      (item) => item?.notesType === "careteammember"
    );
    return { familyNotes, cateteamNotes };
  }, [careteamJournal]);

  const filteredTasks = useMemo(() => {
    return careteamJournal?.Task.filter(
      (task) =>
        (task?.status === "omitted" || task?.status === "true") &&
        task.shiftId === careteamJournal.shiftId
    ).sort((a, b) => {
      if (a.taskType === "wellbeing" && b.taskType !== "wellbeing") return -1;
      if (a.taskType !== "wellbeing" && b.taskType === "wellbeing") return 1;
      return 0;
    });
  }, [careteamJournal]);

  const [openPreview, setOpenPreview] = useState("");

  return (
    <>
      <ImagePreviewModal
        openModal={openPreview !== ""}
        handleClose={() => setOpenPreview("")}
        image={openPreview}
      />
      <div className="col-md-6 tabbingMenu journalListScroll">
        {careteamJournal?.clientId?.length > 0 && (
          <ul className="menuList">
            <li>
              <a>
                {/* <img
                  alt="careteam-profile"
                  src={careteamJournal?.clientId[0]?.image}
                /> */}
                <div className="body">
                  <p>
                    {" "}
                    {careteamJournal?.startingTime} -{" "}
                    {careteamJournal?.endingTime}{" "}
                  </p>
                  <h5>Shift Summary </h5>
                  <p className="timeBox">
                    <span className="ms-3">
                      <Moment format="Do MMM YYYY">
                        {careteamJournal?.Date}
                      </Moment>
                    </span>{" "}
                  </p>
                </div>
              </a>
            </li>
          </ul>
        )}
        <div className="starList">
          {ratingArr.map((item, rIndex) => {
            return (
              <button
                key={rIndex}
                className={rIndex < careteamJournal?.fndfRating ? "active" : ""}
              >
                <FaStar />
              </button>
            );
          })}
        </div>
        <Tab.Container id="left-tabs-example" defaultActiveKey="taB1">
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="taB1">Tasks</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="taB2">Care Notes</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="taB3">Family Notes</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="taB1">
              <ul className={`TasksList ${cx.tasklist}`}>
                <p style={{ color: "#BB6BD9" }}>
                  {careteamJournal?.completedTasks} of{" "}
                  {careteamJournal?.totalTask} Tasks Completed
                </p>

                {filteredTasks?.map((task, tIndex) => {
                  const globalTask = task.globalTask;
                  const conditionsToShowMed =
                    globalTask?.medName &&
                    globalTask?.prn?.toLowerCase() === "no";
                  const conditionsToShowPrn =
                    globalTask?.medName &&
                    globalTask?.prn?.toLowerCase() === "yes";

                  let taskStartTime = "00:00";
                  let taskEndTime = "23:59";
                  if (globalTask?.shiftType?.includes("specific")) {
                    taskStartTime = `${
                      globalTask?.startTime
                      // convertTimeToUserTimeZone(
                      //   globalTask?.startTime,
                      //   careteamJournal.shiftTimeZone
                      // ) ?? "--"
                    }`;
                    taskEndTime = `${
                      globalTask?.endTime
                      // convertTimeToUserTimeZone(
                      //   globalTask?.endTime,
                      //   careteamJournal.shiftTimeZone
                      // ) ?? "--"
                    }`;
                  }

                  if (conditionsToShowMed) {
                    return (
                      <li key={tIndex}>
                        <div className="listRow justify-content-between">
                          <p>
                            <img alt="dd" src={`/admin/images/s10.svg`} />
                            Medication Reminder
                          </p>
                          <p className={`teamNameInNotes me-5`}>
                            {`${taskStartTime} - ${taskEndTime}`}
                          </p>
                          <img
                            src={
                              task?.status === "true"
                                ? "/admin/images/checkedIco.svg"
                                : "/admin/images/crossIco.svg"
                            }
                            className="boxIcons"
                          />
                        </div>
                        <p>{globalTask?.NM}</p>
                        <p>
                          Dose: {globalTask?.doseAmount}{" "}
                          {globalTask?.UDFS_UOMCD}
                        </p>
                        <p>Dose Route: {globalTask?.adminRoute}</p>
                        <p>
                          Meal Consideration: {globalTask?.mealConsideration}
                        </p>
                        {Object.keys(task).includes("comments") &&
                          task?.comments && (
                            <p>Description / Observations: {task?.comments}</p>
                          )}{" "}
                        <p className={`teamNameInNotes`}>
                          {getFullName(task?.client?.[0])} (
                          {extractTimeFromTimestamp(
                            task?.timestamp,
                            currentCareSiteData?.timeZone
                          )}
                          )
                        </p>
                      </li>
                    );
                  }
                  if (conditionsToShowPrn) {
                    return (
                      <li key={tIndex}>
                        <div className="listRow justify-content-between">
                          <p>
                            <img alt="rr" src={`/admin/images/s6.svg`} />
                            PRN Med
                          </p>
                          <img
                            src={
                              task?.status === "true"
                                ? "/admin/images/checkedIco.svg"
                                : "/admin/images/crossIco.svg"
                            }
                            className="boxIcons"
                          />
                        </div>
                        <p>{globalTask?.NM}</p>
                        <p>
                          Dose: {globalTask?.doseAmount}{" "}
                          {globalTask?.UDFS_UOMCD}
                        </p>
                        <p>Dose Route: {globalTask?.adminRoute}</p>
                        <p>
                          Meal Consideration: {globalTask?.mealConsideration}
                        </p>
                        {task?.comments && (
                          <p>Description / Observations: {task?.comments}</p>
                        )}
                        <p className={`teamNameInNotes`}>
                          {getFullName(task?.client?.[0])} (
                          {extractTimeFromTimestamp(
                            task?.timestamp,
                            currentCareSiteData?.timeZone
                          )}
                          )
                        </p>
                      </li>
                    );
                  }
                  const taskImgObj = taskImages.find((elem) =>
                    globalTask?.taskName?.includes(elem?.Ctg)
                  );
                  let mesuredValue = "";
                  if (globalTask?.taskType === "BP") {
                    mesuredValue = task.input
                      ? ` ${task.input?.Systolic_BP?.measureValue || "-"} / ${
                          task.input?.Diastolic_BP?.measureValue || "-"
                        } ${task.input?.Diastolic_BP?.measureType}`
                      : "";
                  } else {
                    mesuredValue =
                      task.input && task.input?.measureValue !== ""
                        ? ` ${task.input?.measureValue || "-"} ${
                            task.input?.measureType
                          }`
                        : "";
                  }
                  const isWellbeing =
                    task.taskCategory === "wellbeing" ||
                    task?.taskType === "wellbeing";
                  return (
                    <>
                      {isWellbeing ? (
                        <Fragment key={tIndex}>
                          <li>
                            <div className="listRow">
                              <img src="/admin/images/s9.svg" />
                              Wellbeing Assessment
                              <img
                                src={
                                  task?.status === "omitted"
                                    ? "/admin/images/crossIco.svg"
                                    : "/admin/images/checkedIco.svg"
                                }
                                className="boxIcons"
                              />
                              {/* <input
                                                    readOnly
                                                    type="checkbox"
                                                    checked={
                                                        careteamJournal?.wellbeingAssessment?.status ===
                                                        "true"
                                                    }
                                                /> */}
                            </div>
                          </li>
                          <Accordion className="colorIcon">
                            <Accordion.Item eventKey="0">
                              <Accordion.Header
                                style={{ borderBottom: "none" }}
                              >
                                <BiSolidDownArrow />
                              </Accordion.Header>
                              <Accordion.Body>
                                <ul>
                                  {wCategories.map((wellCat, wIndex) => {
                                    const ratingCount = [1, 2, 3, 4, 5, 6];
                                    const rating = task?.[wellCat.wCat] ?? 0;
                                    return (
                                      <li key={wIndex}>
                                        <label>{wellCat.displayName}</label>
                                        <div>
                                          {ratingCount.map((count) => (
                                            <button key={count}>
                                              <img
                                                className={
                                                  rating === count
                                                    ? "wellbineColor"
                                                    : ""
                                                }
                                                src={`/admin/images/is${count}.svg`}
                                              />
                                            </button>
                                          ))}
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                          {task?.reason && task?.status === "omitted" && (
                            <p className="mt-1">{`Reason: ${task?.reason}`}</p>
                          )}
                          <p className={`teamNameInNotes`}>
                            {getFullName(task?.client?.[0])} ( (
                            {extractTimeFromTimestamp(
                              task?.timestamp,
                              currentCareSiteData?.timeZone
                            )}
                            ) )
                          </p>
                        </Fragment>
                      ) : (
                        <li key={tIndex}>
                          <div className="listRow justify-content-between">
                            <p>
                              <img alt="icon" src={taskImgObj?.image} />
                              {task?.taskName}
                            </p>
                            <p className={`teamNameInNotes me-5`}>
                              {`${taskStartTime} - ${taskEndTime}`}
                            </p>
                            {/* {globalTask?.startTime &&
                              globalTask?.startTime !== "" &&
                              globalTask?.startTime !== "No" && (
                                <p className={`teamNameInNotes me-5`}>
                                  {convertTimeToUserTimeZone(
                                    globalTask?.startTime,
                                    careteamJournal?.shiftTimeZone
                                  )}
                                </p>
                              )} */}
                            <img
                              src={
                                task?.status === "omitted"
                                  ? "/admin/images/crossIco.svg"
                                  : task?.status === "true"
                                  ? "/admin/images/checkedIco.svg"
                                  : "/admin/images/blankCheck.svg"
                              }
                              className="boxIcons"
                            />
                          </div>
                          <p>
                            {globalTask?.taskType}: {mesuredValue || "-"}
                          </p>
                          <p>
                            Description / Observations: {task?.comments || "-"}
                          </p>
                          {task?.reason && task?.status === "omitted" && (
                            <p>{`Reason: ${task?.reason}`}</p>
                          )}
                          <p className={`teamNameInNotes`}>
                            {getFullName(task?.client?.[0])} (
                            {extractTimeFromTimestamp(
                              task?.timestamp,
                              currentCareSiteData?.timeZone
                            )}
                            )
                          </p>
                        </li>
                      )}
                    </>
                  );
                })}
              </ul>
            </Tab.Pane>
            <Tab.Pane eventKey="taB2">
              {filteredNotes?.cateteamNotes?.map((elem) => (
                <div className="rightTextTabs" key={elem._id}>
                  {elem.media && (
                    <BasicButton onClick={() => setOpenPreview(elem.media)}>
                      <img src={elem.media} />
                    </BasicButton>
                  )}
                  <p>{elem.notesData}</p>
                  <p>
                    {getFullName(elem?.clientData?.[0])} (
                    {extractTimeFromTimestamp(
                      elem?.createdAt,
                      currentCareSiteData?.timeZone
                    )}
                    )
                  </p>
                </div>
              ))}
              {filteredNotes?.cateteamNotes?.length < 1 && (
                <p>No data available</p>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="taB3">
              {filteredNotes?.familyNotes?.map((elem) => (
                <div className="rightTextTabs" key={elem._id}>
                  {elem.media && (
                    <BasicButton onClick={() => setOpenPreview(elem.media)}>
                      <img src={elem.media} />
                    </BasicButton>
                  )}
                  <p>{elem.notesData}</p>
                  <p>
                    {getFullName(elem?.clientData?.[0])} (
                    {extractTimeFromTimestamp(
                      elem?.createdAt,
                      currentCareSiteData?.timeZone
                    )}
                    )
                  </p>
                </div>
              ))}
              {filteredNotes?.familyNotes?.length < 1 && (
                <p>No data available</p>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};

export default JournalDetailAgency;
